import React from 'react'

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './Home.css';

import {Autoplay } from "swiper/modules";


import { Navigation } from 'swiper/modules';
import ImageGallery from './ImageGallery';


import Company from './Company';// Make sure to import Swiper styles

function Home() {
    const styles = {
        section: {
            padding: '70px 0',
            background: 'linear-gradient(#ff7800)',
            width: '100%',
            minHeight: '600px',
            display: 'flex',
            alignItems: 'center'
        },
        container: {
            width: '100%',
            maxWidth: '1400px',
            margin: '0 auto',
            padding: window.innerWidth <= 768 ? '0 20px' : '0 60px',
            position: 'relative'
        },
        decorativeLine: {
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: window.innerWidth <= 768 ? '80px' : '120px',
            height: window.innerWidth <= 768 ? '6px' : '8px',
            backgroundColor: '#ff7800',
            borderRadius: '9999px',
            marginTop: '-20px'
        },
        heading: {
            fontSize: window.innerWidth <= 768 ? '32px' : '48px',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: window.innerWidth <= 768 ? '40px' : '60px',
            color: '#1f2937',
            letterSpacing: '-0.025em',
            padding: '0 20px'
        },
        contentWrapper: {
            position: 'relative',
            maxWidth: window.innerWidth <= 768 ? '100%' : '80rem',
            margin: '0 auto',
            padding: window.innerWidth <= 768 ? '20px' : '40px'
        },
        cornerTopLeft: {
            position: 'absolute',
            top: window.innerWidth <= 768 ? '-15px' : '-30px',
            left: window.innerWidth <= 768 ? '-15px' : '-30px',
            width: window.innerWidth <= 768 ? '30px' : '60px',
            height: window.innerWidth <= 768 ? '30px' : '60px',
            borderTop: '3px solid #ff7800',
            borderLeft: '3px solid #ff7800'
        },
        cornerBottomRight: {
            position: 'absolute',
            bottom: window.innerWidth <= 768 ? '-15px' : '-30px',
            right: window.innerWidth <= 768 ? '-15px' : '-30px',
            width: window.innerWidth <= 768 ? '30px' : '60px',
            height: window.innerWidth <= 768 ? '30px' : '60px',
            borderBottom: '3px solid #ff7800',
            borderRight: '3px solid #ff7800'
        },
        paragraph: {
            fontSize: window.innerWidth <= 768 ? '16px' : '20px',
            textAlign: 'center',
            lineHeight: '1.8',
            color: '#374151',
            padding: window.innerWidth <= 768 ? '30px 20px' : '50px 70px',
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            textAlign:'left',
            boxShadow: '0 15px 30px -5px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
        }
    };

    const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div>
            {/* <!-- Hero-3-Start --> */}
            {/* <section class="hero-section-1">
                <div class="hs1">
                    <div class="slider hs1-content">
                        <div class="hs1-content-wrapper">
                            <div class="swiper-container">
                                <div class="swiper-wrapper">
                                    
                                    <div class="swiper-slide">
                                        <div class="content">
                                            <div class="hs1-bg">
                                                <img src="./assets/images_colored/homepage.jpg" title="hero-slider-1-img-1" alt="bw-hero-slider-1-img-1" />
                                            </div>
                                            <div class="container">
                                                <div class="hero-main-content">
                                                    <div class="headings">
                                                        <h5 class="sub-heading" style={{fontWeight:'bold',fontSize:'25px'}}>Welcome to Sri Engineering(Tool Room).</h5>
                                                        <h1 class="hero--heading">
                                                            Shaping industries with quality solutions.
                                                        </h1>
                                                        <div class="hero-btns">
                                                            <a class="button" href="/about">
                                                                <div class="button-inner">
                                                                    <span>LEARN MORE</span>
                                                                    <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                        <path
                                                                            d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            </a>
                                                            <a class="button white--btn" href="/contact">
                                                                <div class="button-inner">
                                                                    <span>Contact Us</span>
                                                                    <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                        <path
                                                                            d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="content">
                                            <div class="hs1-bg">
                                                <img src="./assets/images_colored/hero-slider-1-img-2.jpg" title="hero-slider-1-img-1" alt="bw-hero-slider-1-img-1" />
                                            </div>
                                            <div class="container">
                                                <div class="hero-main-content">
                                                    <div class="headings">
                                                        <h5 class="sub-heading">Welcome to Sri Engineering(Tool Room).</h5>
                                                        <h1 class="hero--heading">
                                                            Shaping industries with quality solutions.
                                                        </h1>
                                                        <div class="hero-btns">
                                                            <a class="button" href="about.html">
                                                                <div class="button-inner">
                                                                    <span>LEARN MORE</span>
                                                                    <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                        <path
                                                                            d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            </a>
                                                            <a class="button white--btn" href="contact.html">
                                                                <div class="button-inner">
                                                                    <span>Contact Us</span>
                                                                    <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                        <path
                                                                            d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="content">
                                            <div class="hs1-bg">
                                                <img src="./assets/images_colored/hero-slider-1-img-3.jpg" title="hero-slider-1-img-1" alt="bw-hero-slider-1-img-1" />
                                            </div>
                                            <div class="container">
                                                <div class="hero-main-content">
                                                    <div class="headings">
                                                        <h5 class="sub-heading">Welcome to Rodio.</h5>
                                                        <h1 class="hero--heading">
                                                            Your ideas realized for real world.
                                                        </h1>
                                                        <div class="hero-btns">
                                                            <a class="button" href="about.html">
                                                                <div class="button-inner">
                                                                    <span>LEARN MORE</span>
                                                                    <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                        <path
                                                                            d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            </a>
                                                            <a class="button white--btn" href="contact.html">
                                                                <div class="button-inner">
                                                                    <span>Contact Us</span>
                                                                    <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                        <path
                                                                            d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="content">
                                            <div class="hs1-bg">
                                                <img src="./assets/images_colored/hero-slider-1-img-4.jpg" title="hero-slider-1-img-1" alt="bw-hero-slider-1-img-1" />
                                            </div>
                                            <div class="container">
                                                <div class="hero-main-content">
                                                    <div class="headings">
                                                        <h5 class="sub-heading">Welcome to Rodio.</h5>
                                                        <h1 class="hero--heading">
                                                            Concrete planning for grand growth.
                                                        </h1>
                                                        <div class="hero-btns">
                                                            <a class="button" href="about.html">
                                                                <div class="button-inner">
                                                                    <span>LEARN MORE</span>
                                                                    <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                        <path
                                                                            d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            </a>
                                                            <a class="button white--btn" href="contact.html">
                                                                <div class="button-inner">
                                                                    <span>Contact Us</span>
                                                                    <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                        <path
                                                                            d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    
                                </div>
                            </div>
                           <div class="slider-nav-wrapper">
                                <div class="container">
                                    <div class="slider-nav">
                                        <div class="slider-nav-btn slider-nav-prev">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                                                <path
                                                    d="M203.9 405.3c5.877 6.594 5.361 16.69-1.188 22.62c-6.562 5.906-16.69 5.375-22.59-1.188L36.1 266.7c-5.469-6.125-5.469-15.31 0-21.44l144-159.1c5.906-6.562 16.03-7.094 22.59-1.188c6.918 6.271 6.783 16.39 1.188 22.62L69.53 256L203.9 405.3z"
                                                ></path>
                                            </svg>
                                        </div>
                                        <div class="slider-nav-btn slider-nav-next">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                                                <path
                                                    d="M219.9 266.7L75.89 426.7c-5.906 6.562-16.03 7.094-22.59 1.188c-6.918-6.271-6.783-16.39-1.188-22.62L186.5 256L52.11 106.7C46.23 100.1 46.75 90.04 53.29 84.1C59.86 78.2 69.98 78.73 75.89 85.29l144 159.1C225.4 251.4 225.4 260.6 219.9 266.7z"
                                                ></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </section> */}

<section className="hero-section-1">
      <div className="hs1">
        <div className="slider hs1-content">
          <div className="hs1-content-wrapper">
            <Swiper
              modules={[Navigation,Autoplay]}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              loop
              style={{color:'#ff7800'}}
            >
              <SwiperSlide>
                <div className="content">
                  <div className="hs1-bg">
                    <img src="./assets/images_colored/homepage.jpg" alt="hero-slider-1" />
                  </div>
                  <div className="container">
                    <div className="hero-main-content">
                      <div className="headings">
                        <h5 className="sub-heading" style={{ fontWeight: "bold", fontSize: "25px" }}>
                          Welcome to Sri Engineering.
                        </h5>
                        <h1 className="hero--heading">Shaping industries with quality solutions.</h1>
                        <div className="hero-btns">
                          <a className="button" href="/about">
                            <div className="button-inner">
                              <span>LEARN MORE</span>
                            </div>
                          </a>
                          <a className="button white--btn" href="/contact">
                            <div className="button-inner">
                              <span>Contact Us</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="content">
                  <div className="hs1-bg">
                    <img src="./assets/images_colored/Electricalt.jpg" alt="hero-slider-2" />
                  </div>
                  <div className="container">
                    <div className="hero-main-content">
                      <div className="headings">
                        <h5 className="sub-heading" style={{ fontWeight: "bold", fontSize: "25px" }}>Welcome to Sri Engineering.</h5>
                        <h1 className="hero--heading">Shaping industries with quality solutions.</h1>
                        <div className="hero-btns">
                          <a className="button" href="/about">
                            <div className="button-inner">
                              <span>LEARN MORE</span>
                            </div>
                          </a>
                          <a className="button white--btn" href="/contact">
                            <div className="button-inner">
                              <span>Contact Us</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="content">
                  <div className="hs1-bg">
                    <img src="./assets/images_colored/Car21.png" alt="hero-slider-3" />
                  </div>
                  <div className="container">
                    <div className="hero-main-content">
                      <div className="headings">
                        <h5 className="sub-heading" style={{ fontWeight: "bold", fontSize: "25px" }}>Welcome to Sri Engineering.</h5>
                        <h1 className="hero--heading">Shaping industries with quality solutions.</h1>
                        <div className="hero-btns">
                          <a className="button" href="/about">
                            <div className="button-inner">
                              <span>LEARN MORE</span>
                            </div>
                          </a>
                          <a className="button white--btn" href="/contact">
                            <div className="button-inner">
                              <span>Contact Us</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </section>
            <section class="toggle-card-section" style={{ height: "110vh" }}>
                <div class="container">
                    <div class="toggle-card-wrapper">
                        <div class="rodio-tabs tab-landscape">
                            <div class="rodio-tabs-inner">
                                <div class="tabs-wrapper wow animate__animated custom-fadeInUp" data-wow-duration="2s">
                                    {/* <!-- Tab-links Start --> */}
                                    <ul class="nav nav-tabs mobile-hidden" id="tab-container-4ceef20">
                                        {/* <li class="nav-item" role="presentation">
                                            <button class="nav-link active" id="rodio-tab-bbed5c0" data-value="rodio-tab-bbed5c0" data-bs-toggle="tab" data-bs-target="#rodio-target-bbed5c0" type="button" role="tab" aria-controls="rodio-target-bbed5c0" aria-selected="false" data-selected="">
                                                <span class="icon-wrapper">
                                                    <svg
                                                        class="icon"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 640 512"
                                                    >
                                                        <path
                                                            d="M119.1 33.74l-64-31.1c-7.875-3.1-17.5-.875-21.38 7.125c-4 7.875-.875 17.5 7.125 21.37l64 31.1C107.1 63.36 109.5 63.99 112 63.99c7.375 0 13.88-5.125 15.62-12.37C129.3 44.49 125.8 36.99 119.1 33.74zM112 287.1c-2.5 0-4.875 .625-7.125 1.75l-64 31.1c-8 3.875-11.12 13.5-7.25 21.37c4 7.1 13.62 11.12 21.5 7.25l64-31.1c6.625-3.375 10.12-10.87 8.5-17.1C125.9 293.1 119.4 287.1 112 287.1zM528 63.99c2.5 0 4.875-.625 7.125-1.75l64-31.1c8-3.875 11.12-13.5 7.125-21.37c-3.875-7.1-13.5-11.12-21.38-7.125l-64 31.1c-6.625 3.25-10.12 10.75-8.5 17.87C514.1 58.86 520.6 63.99 528 63.99zM96 175.1C96 167.1 88.88 159.1 80 159.1h-64c-8.875 0-16 7.125-16 15.1S7.125 191.1 16 191.1h64C88.88 191.1 96 184.9 96 175.1zM624 159.1h-64c-8.875 0-16 7.125-16 15.1s7.125 15.1 16 15.1h64c8.875 0 16-7.125 16-15.1S632.9 159.1 624 159.1zM599.1 321.7l-64-31.1c-7.875-3.1-17.5-.75-21.5 7.125c-3.875 7.875-.75 17.5 7.25 21.5l64 31.1c7.875 3.875 17.5 .75 21.5-7.25C610.3 335.2 607.1 325.6 599.1 321.7zM319.5 .0154C222.7 .2967 144 79.89 144 177.4c0 42.91 15.47 84.34 43.55 116.6c13.33 15.31 35.84 49.59 43.73 76.02c1.078 8.687 8.844 14.62 17.64 13.71c8.703-.9687 14.98-8.965 14.11-17.65l-.6094-3.312c-10.31-34.97-36-72.84-50.73-89.77C188.7 246.5 176 212.6 176 177.4c0-81.24 63.05-145.1 143.5-145.3H320c38.13 0 74.05 14.87 101.2 41.94C448.8 101.5 464 138.2 464 177.4c0 35.19-12.67 69.15-35.67 95.62c-14.75 16.94-40.44 54.8-50.75 89.77l-.625 3.344c-1.047 8.75 4.938 17.59 13.67 18.68c.7813 .0938 1.531 .1562 2.281 .1562c7.797 0 14.36-5.121 15.36-13.12c8.344-28.25 30.86-62.53 44.2-77.84C480.5 261.7 496 220.3 496 177.4c0-47.71-18.55-92.49-52.22-126.1C410.5 18.08 365.6-1.172 319.5 .0154zM383.1 415.1H256c-8.846 0-16.01 7.18-16 16.03l.0746 22.34c.0098 6.27 1.884 12.46 5.359 17.68l17.09 25.69c5.225 7.855 17.22 14.28 26.65 14.28h61.72c9.418 0 21.41-6.43 26.63-14.27l17.09-25.69c2.953-4.441 5.351-12.36 5.359-17.68l-.0254-22.34C399.1 423.2 392.8 415.1 383.1 415.1zM367.9 454.4l-16.11 24.45c-.4766 .4375-1.686 1.086-.8672 1.117l-60.29 .1172c-.4238-.1016-1.138-.2773-1.423-.2773c-.1406 0-.1348-.2266 0 0l-17.1-25.48l-.0098-6.367h95.94l.0039 5.18C367.9 453.6 367.7 454.4 367.9 454.4C367.9 454.4 367.8 454.5 367.9 454.4zM336 80.02c0-8.84-7.156-16-16-16c-61.75 0-112 50.24-112 111.1c0 8.844 7.156 16 16 16s16-7.159 16-16c0-44.1 35.88-79.1 80-79.1C328.8 96.01 336 88.86 336 80.02z"
                                                        ></path>
                                                    </svg>
                                                </span>
                                                <span class="button-list-text">Injection Moulding Solutions</span>
                                            </button>
                                        </li> */}
                                      
                                    </ul>
                                    {/* <select data-source-selector="li button" data-source-target="#tab-container-4ceef20">
                                        <option
                                            value="rodio-tab-bbed5c0"
                                            selected=""
                                            data-selected=""
                                        >
                                            &nbsp;
                                        </option>
                                        <option value="rodio-tab-f2b44c2">&nbsp;</option>
                                        <option value="rodio-tab-38e306d">&nbsp;</option>
                                        <option value="rodio-tab-664cc72">&nbsp;</option>
                                    </select> */}
                                    {/* <!-- Tab-links end --> */}
                                </div>
                                {/* <!-- Tab-panel Start --> */}
                                <div class="tab-content wow animate__animated custom-fadeInUp">
                                    <div class="tab-pane active first-render elementor-repeater-item-bbed5c0 tab-template" id="sri-engineering-target-bbed5c0" role="tabpanel" aria-labelledby="sri-engineering-tab-bbed5c0">
                                        <div class="tab-pane-inner">
                                            <div class="tab-panel-wrapper">
                                                <div class="pane-content-block">
                                                    <h1 class="primary--heading"> Injection Moulding Solutions</h1>
                                                    <p>
                                                    Engineering & Injection Moulding
                                                    at Sri Engineering(Tool Room), we specialize in engineering moulding and injection moulding, delivering high-quality, durable components for a wide range of industries. Our advanced manufacturing capabilities ensure precision and efficiency in every project.
                                                    </p>
                                                    <p>
                                                        Our state-of-the-art manufacturing facilities and commitment to excellence drive innovation in engineering and product development.
                                                    </p>
                                                    <a class="button" href="/about">
                                                        <div class="button-inner">
                                                            <span>LEARN MORE</span>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="about-img-block" >
                                                    <div data-extend class="r-image overlap">
                                                        <div class="r-image-inner responive_naya_image_aboutus" style={{height:"100%"}}>
                                                            <img src="./assets/images_colored/injc.png" alt="About-img" style={{border:"5px solid #ffffff",borderRadius:"10px"}}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tab-pane elementor-repeater-item-f2b44c2 tab-template" id="sri-engineering-target-f2b44c2" role="tabpanel" aria-labelledby="sri-engineering-tab-f2b44c2">
                                        <div class="tab-pane-inner">
                                            <div class="tab-panel-wrapper">
                                                <div class="pane-content-block">
                                                    <h1 class="primary--heading">Innovative Solutions</h1>
                                                    <p>
                                                        Our expert team continuously innovates to provide industry-leading engineering solutions, enhancing efficiency and productivity.
                                                    </p>
                                                    <p>
                                                        From prototyping to full-scale production, we deliver high-quality moulding and tooling services tailored to client needs.
                                                    </p>
                                                    <a class="button" href="contact.html">
                                                        <div class="button-inner">
                                                            <span>LEARN MORE</span>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="about-img-block" >
                                                    <div data-extend class="r-image overlap">
                                                        <div class="r-image-inner">
                                                            <img src="./assets/images_colored/tab-img-02.jpg" alt="About-img" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tab-pane elementor-repeater-item-38e306d tab-template" id="sri-engineering-target-38e306d" role="tabpanel" aria-labelledby="sri-engineering-tab-38e306d">
                                        <div class="tab-pane-inner">
                                            <div class="tab-panel-wrapper">
                                                <div class="pane-content-block">
                                                    <h1 class="primary--heading">Quality & Reliability</h1>
                                                    <p>
                                                        Our ISO 9001:2015 certification reflects our commitment to delivering products with the highest quality and reliability standards.
                                                    </p>
                                                    <p>
                                                        With rigorous quality control measures, we ensure each component meets exact specifications and industry requirements.
                                                    </p>
                                                    <a class="button" href="contact.html">
                                                        <div class="button-inner">
                                                            <span>LEARN MORE</span>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="about-img-block">
                                                    <div data-extend class="r-image overlap">
                                                        <div class="r-image-inner">
                                                            <img src="./assets/images_colored/tab-img-03.jpg" alt="About-img" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tab-pane elementor-repeater-item-664cc72 tab-template" id="sri-engineering-target-664cc72" role="tabpanel" aria-labelledby="sri-engineering-tab-664cc72">
                                        <div class="tab-pane-inner">
                                            <div class="tab-panel-wrapper">
                                                <div class="pane-content-block">
                                                    <h1 class="primary--heading">Future Growth</h1>
                                                    <p>
                                                        By 2024-25, Sri Engineering(Tool Room) aims to expand production capacity, introduce new technologies, and onboard global clients.
                                                    </p>
                                                    <p>
                                                        With continuous improvements and strategic investments, we are shaping the future of precision engineering.
                                                    </p>
                                                    <a class="button" href="/about">
                                                        <div class="button-inner">
                                                            <span>LEARN MORE</span>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="about-img-block">
                                                    <div data-extend class="r-image overlap">
                                                        <div class="r-image-inner">
                                                            <img src="./assets/images_colored/tab-img-04.jpg" alt="About-img" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* <!-- Tab-panel end --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Hero-3-End --> */}

            <section className='homesection'>
                <div style={styles.container}>
                    <div style={styles.decorativeLine}></div>
                    <h2 style={styles.heading}>About Us</h2>
                    <div style={styles.contentWrapper}>
                        <div style={styles.cornerTopLeft}></div>
                        <div style={styles.cornerBottomRight}></div>
                        <p style={styles.paragraph}>
                        Sri Engineering(Tool Room) is a leading provider of engineering moulding and injection moulding solutions, delivering high-quality and innovative products to various industries.
                        </p>
                    </div>
                </div>
            </section>

            {/* <!-- Work-v1-Start --> */}
            <div class="work-v1-light-section">
                <section class="work-v1-section work-v1-colored wow animate__animated custom-fadeInUp" data-wow-duration="2s">
                    <div class="container wow animate__animated custom-fadeInUp" data-wow-duration="2s">
                        <h2 class="primary--heading" style={{marginTop:"20px", marginBottom:"20px"}}>
                        Our Expertise:
                        </h2>

                        <div class="work-cards-wrapper row-masonry" data-masonry-options='{ "percentPosition": true, "horizontalOrder": true, "transitionDuration": 0, "gutter": 30 }'>
                            <div class="image-box">
                                
                                <div class="image-box-content">
                                <div class="image-box-image">
                                    <img src="./assets/images_colored/mm2.jpg" alt="bw-service-img-01" style={{marginLeft:"10px" }}/>
                                </div>
                                    <div class="image-box-content-inner">

                                        <h4>Injection Moulding</h4>
                                        <div class="content">
                                            <p class="transparent-white-color">
                                            High-performance solutions for durable and intricate components
                                            </p>
                                        </div>
                                       
                                    </div>
                                </div>
                                <div class="image-box-bg"></div>
                            </div>

                            
                            <div class="image-box">
                                
                                <div class="image-box-content">
                                <div class="image-box-image">
                                    <img src="./assets/images_colored/mm1.jpg" alt="bw-service-img-01" style={{marginLeft:"10px"}}/>
                                </div>
                                    <div class="image-box-content-inner">
                                         
                                        <h4>Engineering Moulding</h4>
                                        <div class="content">
                                            <p class="transparent-white-color">
                                            Advanced manufacturing techniques ensuring precision and efficiency
                                            </p>
                                        </div>
                                     
                                    </div>
                                </div>
                                <div class="image-box-bg"></div>
                            </div>


                            <div class="image-box">
                               
                                <div class="image-box-content">
                                <div class="image-box-image">
                                    <img src="./assets/images_colored/ht.png" alt="bw-service-img-03" style={{marginLeft:"10px"}}/>
                                </div>
                                    <div class="image-box-content-inner">

                                        <h4>Hot Runner Moulds</h4>
                                        <div class="content">
                                            <p class="transparent-white-color">
                                            Cost-effective, sustainable, and high-precision moulding solutions.
                                            </p>
                                        </div>
                                       
                                    </div>
                                </div>
                                <div class="image-box-bg"></div>
                            </div>
                            {/* <div class="image-box">
                        <div class="image-box-image">
                            <img src="./assets/images_colored/service-img-04.jpg" alt="bw-service-img-04"/>
                        </div>
                        <div class="image-box-content">
                            <div class="image-box-content-inner">
                                <span>
                  <svg
                    class="icon-svg icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 496 512"
                  >
                    <path
                      d="M305.05 98.74l23.96 53.62-92.33 92.33c-6.25 6.25-6.25 16.38 0 22.62 3.12 3.12 7.22 4.69 11.31 4.69s8.19-1.56 11.31-4.69l92.33-92.33 53.62 23.96a20.547 20.547 0 0 0 21.04-4.96l63.67-63.67c10.8-10.8 6.46-29.2-8.04-34.04l-55.66-18.55-18.55-55.65C404.73 13.08 396.54 8 388.16 8c-5.14 0-10.36 1.92-14.47 6.03L310.02 77.7a20.582 20.582 0 0 0-4.97 21.04zm78.18-48.99l12.7 38.09 5.06 15.18 15.18 5.06 38.09 12.7-44.93 44.93-49.09-21.93-21.93-49.09 44.92-44.94zm101.2 131.35l-26.18 26.18c3.63 15.69 5.75 31.95 5.75 48.72 0 119.1-96.9 216-216 216S32 375.1 32 256 128.9 40 248 40c16.78 0 33.04 2.11 48.72 5.75l26.18-26.18A247.848 247.848 0 0 0 248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248c0-26.11-4.09-51.26-11.57-74.9zM274.7 108.85a53.056 53.056 0 0 1-2.68-14.44C264.12 93.25 256.23 92 248 92c-90.65 0-164 73.36-164 164 0 90.65 73.36 164 164 164 90.65 0 164-73.36 164-164 0-8.35-1.25-16.35-2.45-24.36-4.89-.21-9.76-.79-14.41-2.34-2.12-.71 1.02.62-20.69-9.07C377.7 231.68 380 243.52 380 256c0 72.79-59.21 132-132 132s-132-59.21-132-132 59.21-132 132-132c12.48 0 24.32 2.3 35.77 5.55-9.69-21.7-8.36-18.56-9.07-20.7zM248 176c-44.11 0-80 35.89-80 80s35.89 80 80 80 80-35.89 80-80c0-3.77-.61-7.38-1.11-11.01l-44.95 44.95-.01-.01c-8.7 8.69-20.7 14.07-33.93 14.07-26.47 0-48-21.53-48-48 0-13.23 5.38-25.23 14.07-33.93l-.01-.01 44.95-44.95c-3.63-.5-7.24-1.11-11.01-1.11z"
                    ></path>
                  </svg>
                </span>
                                <h4>Digital Marketing</h4>
                                <div class="content">
                                    <p class="transparent-white-color">
                                        Sea abundantly multiply have greater open doesn't they're by over you're you'll may there was blessed over forth bring.
                                    </p>
                                </div>
                                <div class="reveal"></div>
                            </div>
                        </div>
                        <div class="image-box-bg"></div>
                    </div>
                    <div class="image-box">
                        <div class="image-box-image">
                            <img src="./assets/images_colored/service-img-05.jpg" alt="bw-service-img-05"/>
                        </div>
                        <div class="image-box-content">
                            <div class="image-box-content-inner">
                                <span>
                  <svg
                    class="icon-svg icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      d="M504 416H32V72c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v360c0 8.84 7.16 16 16 16h488c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM98.34 263.03c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l72.69-72.01 84.69 84.69c6.25 6.25 16.38 6.25 22.63 0l93.53-93.53 44.04 44.04c4.95 4.95 11.03 7.16 17 7.16 12.48 0 24.46-9.7 24.46-24.34V112.19c0-8.94-7.25-16.19-16.19-16.19H344.34c-21.64 0-32.47 26.16-17.17 41.46l44.71 44.71-82.22 82.22-84.63-84.63c-6.23-6.23-16.32-6.25-22.57-.05l-84.12 83.32zM362.96 128H448v85.04L362.96 128z"
                    ></path>
                  </svg>
                </span>
                                <h4>Advanced Analytics</h4>
                                <div class="content">
                                    <p class="transparent-white-color">
                                        Sea abundantly multiply have greater open doesn't they're by over you're you'll may there was blessed over forth bring.
                                    </p>
                                </div>
                                <div class="reveal"></div>
                            </div>
                        </div>
                        <div class="image-box-bg"></div>
                    </div>
                    <div class="image-box">
                        <div class="image-box-image">
                            <img src="./assets/images_colored/service-img-06.jpg" alt="bw-service-img-06"/>
                        </div>
                        <div class="image-box-content">
                            <div class="image-box-content-inner">
                                <span>
                  <svg
                    class="icon-svg icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 512"
                  >
                    <path
                      d="M64 240c-28.28 0-64 21.84-64 64c0 35.25 28.75 64 64 64s64-28.75 64-64C128 262.1 92.68 240 64 240zM64 336c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S81.63 336 64 336zM184 288H167.1C159.2 288 152 295.2 152 303.1S159.2 320 167.1 320h16.05C192.8 320 200 312.8 200 304S192.8 288 184 288zM576 192c28.28 0 64-21.84 64-64c0-42.01-35.62-64-64-64c-28.28 0-64 21.84-64 64C512 163.3 540.8 192 576 192zM576 96c17.62 0 32 14.38 32 32s-14.38 32-32 32s-32-14.38-32-32S558.4 96 576 96zM576 384c-13.25 0-25.62 4-35.75 10.88c-3.375 2.25-6.375 4.75-9.125 7.5l-91.88-55.13C444.9 334 448 319.3 448 304C448 242.1 397.9 192 336 192c-11.25 0-21.88 2.25-32.25 5.25L264.5 113.1C278.8 101.4 288 83.88 288 64c0-41.93-35.32-64-64-64C182.1 0 160 35.31 160 64c0 35.25 28.75 64 64 64c4 0 7.875-.5 11.75-1.25l39 83.63C244.3 230.4 224 264.8 224 304c0 61.88 50.13 112 112 112c35 0 65.75-16.38 86.38-41.5l92.38 55.38C513.1 435.8 512 441.8 512 448c0 35.25 28.62 64 64 64C618.2 512 640 476.4 640 448C640 420.5 618.4 384 576 384zM224 96C206.4 96 192 81.63 192 64s14.38-32 32-32s32 14.38 32 32S241.6 96 224 96zM336 384C291.9 384 256 348.1 256 304S291.9 224 336 224S416 259.9 416 304S380.1 384 336 384zM576 480c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S593.6 480 576 480zM478.4 229.2l22.44-16.83c7.074-5.307 8.492-15.35 3.166-22.41c-5.305-7.025-15.29-8.436-22.34-3.154l-22.44 16.83c-7.074 5.305-8.492 15.35-3.166 22.4C461.3 233.1 471.3 234.5 478.4 229.2z"
                    ></path>
                  </svg>
                </span>
                                <h4>Bussiness Strategy</h4>
                                <div class="content">
                                    <p class="transparent-white-color">
                                        Sea abundantly multiply have greater open doesn't they're by over you're you'll may there was blessed over forth bring.
                                    </p>
                                </div>
                                <div class="reveal"></div>
                            </div>
                        </div>
                        <div class="image-box-bg"></div>
                    </div> */}
                        </div>
                    </div>
                </section>
            </div>
            {/* <!-- Work-v1-End --> */}



            {/* <!-- About-Us-V4-Start --> */}
            {/* <section class="about-us-v4-section about-us-v4-colored">
        <div class="container">
            <div class="about-us-v4 wow animate__animated custom-fadeInUp" data-wow-duration="2s">
                <div class="about-img-block">
                    <div data-extend="left" class="r-image overlap">
                        <div class="r-image-inner">
                            <img src="./assets/images_colored/about-us-img-5.jpg" alt="About-img"/>
                        </div>
                        <div class="icon-box">
                            <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                        <path
                          d="M119.1 33.74l-64-31.1c-7.875-3.1-17.5-.875-21.38 7.125c-4 7.875-.875 17.5 7.125 21.37l64 31.1C107.1 63.36 109.5 63.99 112 63.99c7.375 0 13.88-5.125 15.62-12.37C129.3 44.49 125.8 36.99 119.1 33.74zM112 287.1c-2.5 0-4.875 .625-7.125 1.75l-64 31.1c-8 3.875-11.12 13.5-7.25 21.37c4 7.1 13.62 11.12 21.5 7.25l64-31.1c6.625-3.375 10.12-10.87 8.5-17.1C125.9 293.1 119.4 287.1 112 287.1zM528 63.99c2.5 0 4.875-.625 7.125-1.75l64-31.1c8-3.875 11.12-13.5 7.125-21.37c-3.875-7.1-13.5-11.12-21.38-7.125l-64 31.1c-6.625 3.25-10.12 10.75-8.5 17.87C514.1 58.86 520.6 63.99 528 63.99zM96 175.1C96 167.1 88.88 159.1 80 159.1h-64c-8.875 0-16 7.125-16 15.1S7.125 191.1 16 191.1h64C88.88 191.1 96 184.9 96 175.1zM624 159.1h-64c-8.875 0-16 7.125-16 15.1s7.125 15.1 16 15.1h64c8.875 0 16-7.125 16-15.1S632.9 159.1 624 159.1zM599.1 321.7l-64-31.1c-7.875-3.1-17.5-.75-21.5 7.125c-3.875 7.875-.75 17.5 7.25 21.5l64 31.1c7.875 3.875 17.5 .75 21.5-7.25C610.3 335.2 607.1 325.6 599.1 321.7zM319.5 .0154C222.7 .2967 144 79.89 144 177.4c0 42.91 15.47 84.34 43.55 116.6c13.33 15.31 35.84 49.59 43.73 76.02c1.078 8.687 8.844 14.62 17.64 13.71c8.703-.9687 14.98-8.965 14.11-17.65l-.6094-3.312c-10.31-34.97-36-72.84-50.73-89.77C188.7 246.5 176 212.6 176 177.4c0-81.24 63.05-145.1 143.5-145.3H320c38.13 0 74.05 14.87 101.2 41.94C448.8 101.5 464 138.2 464 177.4c0 35.19-12.67 69.15-35.67 95.62c-14.75 16.94-40.44 54.8-50.75 89.77l-.625 3.344c-1.047 8.75 4.938 17.59 13.67 18.68c.7813 .0938 1.531 .1562 2.281 .1562c7.797 0 14.36-5.121 15.36-13.12c8.344-28.25 30.86-62.53 44.2-77.84C480.5 261.7 496 220.3 496 177.4c0-47.71-18.55-92.49-52.22-126.1C410.5 18.08 365.6-1.172 319.5 .0154zM383.1 415.1H256c-8.846 0-16.01 7.18-16 16.03l.0746 22.34c.0098 6.27 1.884 12.46 5.359 17.68l17.09 25.69c5.225 7.855 17.22 14.28 26.65 14.28h61.72c9.418 0 21.41-6.43 26.63-14.27l17.09-25.69c2.953-4.441 5.351-12.36 5.359-17.68l-.0254-22.34C399.1 423.2 392.8 415.1 383.1 415.1zM367.9 454.4l-16.11 24.45c-.4766 .4375-1.686 1.086-.8672 1.117l-60.29 .1172c-.4238-.1016-1.138-.2773-1.423-.2773c-.1406 0-.1348-.2266 0 0l-17.1-25.48l-.0098-6.367h95.94l.0039 5.18C367.9 453.6 367.7 454.4 367.9 454.4C367.9 454.4 367.8 454.5 367.9 454.4zM336 80.02c0-8.84-7.156-16-16-16c-61.75 0-112 50.24-112 111.1c0 8.844 7.156 16 16 16s16-7.159 16-16c0-44.1 35.88-79.1 80-79.1C328.8 96.01 336 88.86 336 80.02z"
                        ></path>
                      </svg>
                        </div>
                    </div>
                </div>

                <div class="about-us-content-block">
                    <h1 class="primary--heading">
                        Why choose us for your next project.
                    </h1>
                    <p>
                        And be form image us beast green tree first stars lights yielding by isn’t seas man bring so without beginning. Own beast female unto creepeth seasons fish itself forth likeness all.
                    </p>
                    <div class="accordion" id="accordion-parent">
                        <div class="accordion-item shown">
                            <h2 class="accordion-header" id="accordion-heading-1">
                                <button class="accordion-button keep-open" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-1" aria-expanded="true" aria-controls="accordion-collapse-1">
                          <span>Best digital agency in Australia 2020.</span>
                          <span class="icon"></span>
                        </button>
                            </h2>
                            <div id="accordion-collapse-1" class="accordion-collapse collapse show" aria-labelledby="accordion-heading-1" data-bs-parent="#accordion-parent">
                                <div class="accordion-body">
                                    <p>
                                        Land kind us fill him night years there seasons they winged itself replenish seas in face kind by greater can't bring use fill him night years letter stars land.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="accordion-heading-2">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-2" aria-expanded="false" aria-controls="accordion-collapse-2">
                          <span>Ranked top 20 agencies of the decade.</span>
                          <span class="icon"></span>
                        </button>
                            </h2>
                            <div id="accordion-collapse-2" class="accordion-collapse collapse" aria-labelledby="accordion-heading-2" data-bs-parent="#accordion-parent">
                                <div class="accordion-body">
                                    <p>
                                        Land kind us fill him night years there seasons they winged itself replenish seas in face kind by greater can't bring use fill him night years letter stars land.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="accordion-heading-3">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-3" aria-expanded="false" aria-controls="accordion-collapse-3">
                          <span>Honor of working with fortune 400.</span>
                          <span class="icon"></span>
                        </button>
                            </h2>
                            <div id="accordion-collapse-3" class="accordion-collapse collapse" aria-labelledby="accordion-heading-3" data-bs-parent="#accordion-parent">
                                <div class="accordion-body">
                                    <p>
                                        Land kind us fill him night years there seasons they winged itself replenish seas in face kind by greater can't bring use fill him night years letter stars land.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> */}

            {/* <!-- About-Us-V4-Start --> */}
            <section class="about-us-v4-section about-us-v4-colored">
    <div class="container">
        <div class="about-us-v4 wow animate__animated custom-fadeInUp" data-wow-duration="2s">
            <div class="about-img-block" >
                <div data-extend="left" >
                    <div class="r-image-inner responive_naya_image_aboutus" style={{border:"5px solid #ffffff",borderRadius:"10px"}}>
                        <img src="./assets/images_colored/pc1.jpg" alt="About-img" />
                    </div>
                    <div class="icon-box">
                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                            <path d="..." />
                        </svg>
                    </div>
                </div>
            </div>

            <div class="about-us-content-block">
                <h1 class="primary--heading">
                    Excellence in Engineering & Injection Moulding
                </h1>
                <p style={{color:'#fff'}}>
                    At Sri Engineering(Tool Room), we bring over two decades of expertise in engineering and injection moulding, delivering high-quality, precision-driven solutions for a wide range of industries. Our commitment to innovation and excellence ensures top-tier manufacturing services.
                </p>
                <div class="accordion" id="accordion-parent">
                    <div class="accordion-item shown">
                        <h2 class="accordion-header" id="accordion-heading-1">
                            <button class="accordion-button keep-open" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-1" aria-expanded="true" aria-controls="accordion-collapse-1">
                                <span>Trusted by Industry Leaders</span>
                                <span class="icon"></span>
                            </button>
                        </h2>
                        <div id="accordion-collapse-1" class="accordion-collapse collapse show" aria-labelledby="accordion-heading-1" data-bs-parent="#accordion-parent">
                            <div class="accordion-body">
                                <p>
                                    Sri Engineering(Tool Room) has established strong partnerships with global brands in the automotive, industrial, and consumer goods sectors. Our cutting-edge moulding technology and rigorous quality standards make us a trusted name in the industry.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="accordion-heading-2">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-2" aria-expanded="false" aria-controls="accordion-collapse-2">
                                <span>Expertise in Engineering Moulding</span>
                                <span class="icon"></span>
                            </button>
                        </h2>
                        <div id="accordion-collapse-2" class="accordion-collapse collapse" aria-labelledby="accordion-heading-2" data-bs-parent="#accordion-parent">
                            <div class="accordion-body">
                                <p>
                                    Our advanced engineering moulding capabilities ensure precision, efficiency, and durability in every product. We use state-of-the-art machinery and high-performance materials to meet the evolving demands of our clients.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="accordion-heading-3">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-3" aria-expanded="false" aria-controls="accordion-collapse-3">
                                <span>Innovative Injection Moulding Solutions</span>
                                <span class="icon"></span>
                            </button>
                        </h2>
                        <div id="accordion-collapse-3" class="accordion-collapse collapse" aria-labelledby="accordion-heading-3" data-bs-parent="#accordion-parent">
                            <div class="accordion-body">
                                <p>
                                    At Sri Engineering(Tool Room), we utilize advanced injection moulding technology to produce complex, high-precision components with consistency and reliability. Our expertise in tooling and mould design ensures cost-effective solutions without compromising on quality.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* <div class="accordion-item">
                        <h2 class="accordion-header" id="accordion-heading-4">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-4" aria-expanded="false" aria-controls="accordion-collapse-4">
                                <span>Commitment to Sustainability</span>
                                <span class="icon"></span>
                            </button>
                        </h2>
                        <div id="accordion-collapse-4" class="accordion-collapse collapse" aria-labelledby="accordion-heading-4" data-bs-parent="#accordion-parent">
                            <div class="accordion-body">
                                <p>
                                    Sri Engineering(Tool Room) integrates eco-friendly practices in every stage of manufacturing. From sustainable material sourcing to energy-efficient production processes, we are committed to reducing our environmental footprint while ensuring top-quality output.
                                </p>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    </div>
</section>

            {/* <!-- About-Us-V4-End --> */}

            {/* <!-- About-Us-V4-End --> */}


            <Company />




            {/* <!-- Clients-Section-Start --> */}
            <section className="clients-section client-swiper-section">
                <div className="container wow animate__animated custom-fadeInUp" data-wow-duration="2s">
                    <div className="slider-header">
          <h2 className="primary--heading">Our Clients.</h2>
          <div className="client-slider-btns">
            <div className="client-button-prev slider-btn">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                <path
                  d="M203.9 405.3c5.877 6.594 5.361 16.69-1.188 22.62c-6.562 5.906-16.69 5.375-22.59-1.188L36.1 266.7c-5.469-6.125-5.469-15.31 0-21.44l144-159.1c5.906-6.562 16.03-7.094 22.59-1.188c6.918 6.271 6.783 16.39 1.188 22.62L69.53 256L203.9 405.3z"
                ></path>
              </svg>
            </div>
            <div className="client-button-next slider-btn">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                <path
                  d="M219.9 266.7L75.89 426.7c-5.906 6.562-16.03 7.094-22.59 1.188c-6.918-6.271-6.783-16.39-1.188-22.62L186.5 256L52.11 106.7C46.23 100.1 46.75 90.04 53.29 84.1C59.86 78.2 69.98 78.73 75.89 85.29l144 159.1C225.4 251.4 225.4 260.6 219.9 266.7z"
                ></path>
              </svg>
            </div>
          </div>
        </div>

                    <Swiper
                        spaceBetween={50}
                        slidesPerView={4}
                        navigation={{
                            prevEl: '.client-button-prev',
                            nextEl: '.client-button-next',
                        }}
                        modules={[Navigation]}
                        className="swiper clients-swiper"
                    >
                        <SwiperSlide>
                            <a className="client-block">
                                <img
                                    src="./assets/images_colored/c21.png"
                                    alt="Client Logo"
                                    className="swiper-img"
                                />
                            </a>
                        </SwiperSlide>
                        <SwiperSlide>
                            <a className="client-block">
                                <img
                                    src="./assets/images_colored/c2.jpeg"
                                    alt="Client Logo"
                                    className="swiper-img"
                                />
                            </a>
                        </SwiperSlide>
                        <SwiperSlide>
                            <a className="client-block">
                                <img
                                    src="./assets/images_colored/c3.png"
                                    alt="Client Logo"
                                    className="swiper-img"
                                />
                            </a>
                        </SwiperSlide>
                        <SwiperSlide>
                            <a className="client-block">
                                <img
                                    src="./assets/images_colored/c4.jpeg"
                                    alt="Client Logo"
                                    className="swiper-img"
                                />
                            </a>
                        </SwiperSlide>
                        <SwiperSlide>
                            <a className="client-block">
                                <img
                                    src="./assets/images_colored/c5.jpeg"
                                    alt="Client Logo"
                                    className="swiper-img"
                                />
                            </a>
                        </SwiperSlide>
                        <SwiperSlide>
                            <a className="client-block">
                                <img
                                    src="./assets/images_colored/c6.jpeg"
                                    alt="Client Logo"
                                    className="swiper-img"
                                />
                            </a>
                        </SwiperSlide>
                        <SwiperSlide>
                            <a className="client-block">
                                <img
                                    src="./assets/images_colored/c7.jpeg"
                                    alt="Client Logo"
                                    className="swiper-img"
                                />
                            </a>
                        </SwiperSlide>
                        <SwiperSlide>
                            <a className="client-block">
                                <img
                                    src="./assets/images_colored/c8.png"
                                    alt="Client Logo"
                                    className="swiper-img"
                                />
                            </a>
                        </SwiperSlide>


                    </Swiper>
                </div>
            </section>
            {/* <!-- Clients-Section-End --> */}

            <div class="back-to-top scrolled">
                <div class="back-to-top-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                        <path d="M363.9 330.7c-6.271 6.918-16.39 6.783-22.62 1.188L192 197.5l-149.3 134.4c-6.594 5.877-16.69 5.361-22.62-1.188C14.2 324.1 14.73 314 21.29 308.1l159.1-144c6.125-5.469 15.31-5.469 21.44 0l159.1 144C369.3 314 369.8 324.1 363.9 330.7z"></path>
                    </svg>
                </div>
            </div>
        </div>
    )
}

export default Home
